import { FollowUpPageController } from './follow-up-page.controller';
import { FollowUpPageProps } from './follow-up-page.model';

export const FollowUpPage = (props: FollowUpPageProps) => {
  return <FollowUpPageController {...props} />;
};
